module.exports = __webpack_public_path__ + "img/money-1.c3ba2488.png";